import '../../styles/globals.css'
import { Box, Divider, Typography, useMediaQuery } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import { Fragment, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';
import { Paper, Grid } from '@mui/material';

import MembershipTeaserImage1 from '../../images/homepage/sign-up-teaser1.png';

import { InlineIcon } from '@iconify/react';
import FlashPlayer from '../dashboard/adobeanimate/FlashPlayer';

import giveDirectlyLogo from '../../images/causes/icons/give-directly.png';
import evidenceActionLogo from '../../images/causes/icons/evidence-action.png';
import coolEarthLogo from '../../images/causes/icons/cool-earth.png';
import wildAnimalInitiativeLogo from '../../images/causes/icons/wild-animal-initiative.png';
import cleanAirTaskForceLogo from '../../images/causes/icons/clean-air-taskforce.png';
import msfLogo from '../../images/causes/icons/msf.png';
import { useTheme } from '@emotion/react';


function HeaderWelcome() {
    return (
        <Typography variant="body2" sx={{ marginTop: "1.5rem" }}>

        </Typography>
    );
}

function BackButton() {
    return (
        <Box>
            <p className={karmaStyles.homepageDescription}>
                <a href={"/karma"}>
                    back
                </a>
            </p>
        </Box>
    );
}

function HomepageAbout2(props) {

    // access provider context for karma pool
    const karmaContext = useKarmaPoolContext();

    const [redirecting, setRedirecting] = useState(false);

    useEffect(() => {
        if (window.localStorage.getItem("jwtAuthToken") != null) {
            setRedirecting(true);
            //window.location.href = "/karma/dashboard";
            karmaContext.authPingManager.authPingSuccess(() => {
                console.log("auth ping success")
                window.location.href = "/karma/dashboard";
            });
        }
    }, []);

    return (
        <>
            <Box className={karmaStyles.homepageBox} sx={{ paddingRight: "1rem", paddingLeft: "1rem" }}>
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "0.0rem", marginTop: "1.75rem" }}>
                    We help you give more by pooling membership, selfless donations and 10% of all Karmatic revenue.
                </Typography>
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "0.75rem" }}>
                    This helps you give more than you could by donating directly on your own.
                </Typography>
                <Divider variant="middle" aria-hidden="true" sx={{ borderColor: 'rgba(221, 221, 221, 0.65)', margin: "0 auto", marginTop: "1.25rem", width: "14rem" }} />
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "1.75rem" }}>
                    The goals of Karma Pool are simple.
                </Typography>
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "0.75rem" }}>
                    Give members a tangible impact on the causes they care about.
                </Typography>
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "0.75rem" }}>
                    And build a social reactor of good with a sustianable and long term vision.
                </Typography>
                <Divider variant="middle" aria-hidden="true" sx={{ borderColor: 'rgba(221, 221, 221, 0.65)', margin: "0 auto", marginTop: "1.75rem", width: "14rem" }} />
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "1.75rem" }}>
                    <a href={"/karma/register"}>
                    <u><strong>Join the Alpha</strong></u>
                   </a>
                </Typography>
            </Box>

            <Box sx={{ height: "1.375rem" }} />
            <Box>
                <p className={karmaStyles.homepageDescription}>
                    <a href={"/karma/about"}>
                        back
                    </a>
                </p>
            </Box>
            <Box sx={{ height: "1.375rem" }} />
        </>
    );
}

/* Render a row of all the charity icons */
function CharitiesRowSection(props) {
    let theme = useTheme();

    let isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    if (isMobile) {
        console.log("isMobile");
    }

    if (isMobile) {
        return (
            <CharitiesRowSectionMobile />
        );
    }

    return (
        <Box sx={{ justifyContent: "center", alignItems: "center", marginTop: "0.5rem" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href={"https://www.doctorswithoutborders.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={msfLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.givedirectly.org/"} target="_blank" rel="noreferrer">
                    <img src={giveDirectlyLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.evidenceaction.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={evidenceActionLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.catf.us/"} target="_blank" rel="noopener noreferrer">
                    <img src={cleanAirTaskForceLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.coolearth.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={coolEarthLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://wildanimalinitiative.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={wildAnimalInitiativeLogo} alt="logo" width={40} height={40} />
                </a>
            </Box>
        </Box>
    );
}

function CharitiesRowSectionMobile(props) {
    return (
        <Box sx={{ justifyContent: "center", alignItems: "center", marginTop: "0.5rem" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href="https://www.doctorswithoutborders.org/" target="_blank" rel="noopener noreferrer">
                    <img src={msfLogo} alt="Doctors Without Borders Logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.givedirectly.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={giveDirectlyLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.evidenceaction.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={evidenceActionLogo} alt="logo" width={40} height={40} />
                </a>
            </Box>
            <Box sx={{ height: "0.75rem" }} />
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href={"https://www.catf.us/"} target="_blank" rel="noopener noreferrer">
                    <img src={cleanAirTaskForceLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.coolearth.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={coolEarthLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://wildanimalinitiative.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={wildAnimalInitiativeLogo} alt="logo" width={40} height={40} />
                </a>
            </Box>
        </Box>
    );
}

export default HomepageAbout2;


